<template>
  <div class="dialog dialog-login">
    <div class="dialog-title">{{ $t('Reset') }}</div>
    <div class="dialog-main">
      <el-form :model="formData" :rules="rules" ref="loginForm">
        <el-form-item :label="$t('Old Password')" class="input-row" prop="old_password">
          <el-input v-model="formData.old_password" type="password"/>
        </el-form-item>
        <el-form-item :label="$t('New Password')" class="input-row" prop="new_password">
          <el-input type="password" v-model="formData.new_password"/>
        </el-form-item>
        <el-form-item :label="$t('Confirm Password')" class="input-row" prop="password_confirmation">
          <el-input type="password" v-model="formData.password_confirmation"/>
        </el-form-item>
        <button class="primary" @click.prevent="login('loginForm')">{{ $t('Submit') }}</button>
      </el-form>
    </div>
  </div>
</template>

<script>

import util from "@/util";

export default {
  props: [],
  data: function () {
    return {
      formData: {
        old_password: '',
        new_password: '',
        password_confirmation: '',
      },
      rules: {
        old_password: [
          {required: true, trigger: 'change'}
        ],
        new_password: [
          {required: true, trigger: 'change'}
        ],
        password_confirmation: [
          {required: true, trigger: 'change'}
        ]
      }
    }
  },
  methods: {
    login(formName) {
      let vm = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          this.axios.post('/api/junket/changePwd', this.formData)
            .then(function (res) {
                if (res.code !== 200) {
                  vm.$message.error(res.msg);
                } else {
                  const userInfo = JSON.parse(util.getCookie('userInfo'))
                  userInfo.pwd_at = 1
                  util.addCookie('userInfo', JSON.stringify(userInfo), {
                    path: "/",
                    expires: 12 * 3600
                  });
                  vm.$store.commit('login');
                  vm.$router.push({path: '/reservation'});
                }
              }
            ).finally(function () {
            loading.close();
          })
        }
      });
    }
  }
}

</script>
